module.exports = __webpack_public_path__ + "static/img/50.469a4b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/50.png
// module id = JnCc
// module chunks = 0